import { environment } from "@environment";

export const exportCards = [
    {
        id: environment.angular19NxCodeGenerationTemplateId,
        title: 'Generate Web Application',
        key: 'generate-web-application',
        isCheckable: true,
        isCheck: true,
        description: 'Generate a web application with a responsive and maintainable architecture for fast and efficient development.',
        templateData: 'angular'
    },
    {
        id: environment.flutterCodeGenerationTemplateId,
        title: 'Generate Mobile Application',
        key: 'generate-mobile-application',
        isCheckable: true,
        isCheck: false,
        description: 'Generate a mobile application with a responsive and maintainable architecture for fast and efficient development.',
        templateData: 'mobile'
    },
    {
        id: environment.loopback4CodeGenerationTemplateId,
        title: 'Generate Backend and API',
        key: 'generate-backend-and-api',
        isCheckable: true,
        isCheck: true,
        description: 'Generate a backend system and APIs with a scalable and maintainable architecture for fast and efficient development.',
        templateData: 'loopback4'
    }
]
